import { Checkbox } from "@qastanfit/qastan-ui"
import { useSearchParams } from "react-router-dom";
import React from 'react'
import styles from "../styles/pages/Search.module.scss";
import search from "../assets/icons/search.svg";

import empty from '../assets/images/empty.svg'
import image_icon from "../assets/icons/file_types/image_icon.svg"
import word_icon from "../assets/icons/file_types/word_icon.svg";
import pdf_icon from "../assets/icons/file_types/pdf_icon.svg";
import excel_icon from "../assets/icons/file_types/excel_icon.svg";
import mail_icon from "../assets/icons/file_types/mail_icon.svg";
import text_icon from "../assets/icons/file_types/text_icon.svg";
import unknown_icon from "../assets/icons/file_types/unknown_icon.svg";
import powerpoint_icon from "../assets/icons/file_types/powerpoint_icon.svg";
import Detail from "../components/Detail";
import FileDetail from "../components/files/FileDetail";
import { useEffect, useRef, useState } from "react";
import FilePreview from "../components/files/FilePreview";
import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { RootState } from "../store";
import { setNotification } from "../redux/actions";
import { YYYYMMDDtoDate, dateToYYYYMMDD } from "../functions/format";
import { differenceInDays, format, subDays } from "date-fns";
import { getItemById } from "../functions/convert";
import GroupDropdown from "../components/base/GroupDropdown";

import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { DatePickerWithRangePresetsInput } from "../components/ui/datepicker-range-presets";
import { Label } from "../components/ui/label";
import { ChevronsUpDownIcon, Loader2, MessageCircleIcon, X } from "lucide-react";
import { isInterface } from "../functions/general/checks";
import queryString from "query-string";
import axios, { cancelTokenSource } from '../axios/axios'
import useAuth from "src/hooks/useAuth";
import toast from "react-hot-toast";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/ui/table";
import { useQuery } from "react-query";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { getWindevLang } from "src/lib/lang";
import { useInfiniteQuery } from "@tanstack/react-query";
import lodash from 'lodash'
import { hasDoctypeRight } from "src/lib/filter";
import useTable from "src/hooks/useTable";
import { getCookie, setCookie } from "src/functions/general/cookies";
import { CONFIG } from "src/config";

const Search : React.FC = () => {
    const { t, i18n } = useTranslation()
    const dispatch = useAppDispatch();
    const {auth} = useAuth()
    const doctypes:DoctypeObject[] = useAppSelector((state:RootState) => state.doctypes);
    const docgroups:DocgroupObject[] = useAppSelector((state:RootState) => state.docgroups);
    const metatypeList:MetatypeObject[] = useAppSelector((state:RootState) => state.metatypes);

    let [searchParams, setSearchParams] = useSearchParams();

    const [show_filepreview, setshow_filepreview] = useState(false);
    const [show_detail, setshow_detail] = useState(false);

    const [doctypeList, setdoctypeList] = useState<any>()
    const [selectedDoctype, setselectedDoctype] = useState('')

    const selected_doctypes = useRef<string[]>([])
    const [selectedDoctypes, setselectedDoctypes] = useState<Array<string>>([])
    const [ddlUpdater, setddlUpdater] = useState(0)

    
    const sourceRef = useRef<any>(null);
    
    const defaultCheckedContent:boolean = CONFIG.company ? (CONFIG.company[auth.data?.user.companyname || '']?.search_enable_searchcontent || false) : false
    const [checkedSearchContent, setcheckedSearchContent] = useState<boolean>(defaultCheckedContent);
    const [search_value, setsearch_value] = useState('')
    const searchvalue = useRef('');
    const checked_searchcontent = useRef(defaultCheckedContent)

    const defaultAmountDays:number = CONFIG.company ? (CONFIG.company[auth.data?.user.companyname || '']?.search_default_days || 30) : 30
    const [startDate, setstartDate] = useState<Date | undefined>(subDays(new Date(), (Number(getCookie('search_days')) || defaultAmountDays)));
    const [endDate, setendDate] = useState<Date | undefined>(new Date);
    const startdate = useRef<Date | undefined>(subDays(new Date(), (Number(getCookie('search_days')) || defaultAmountDays)));
    const enddate = useRef<Date | undefined>(new Date);
    
    const [selectedDocument, setselectedDocument] = useState<DocumentObject>()

    async function getSearchResults(test:any) {
        // Create a new cancel token source
        sourceRef.current = cancelTokenSource;

        const searchObject = {
            // token: auth.data?.token,
            token: '',
            searchstring: searchvalue.current,
            searchcontent: checked_searchcontent.current ? 1 : 0,
            startdate: '',
            enddate: '',
            doctypes: '',
            offset: (test.pageParam)*50,
            limit: 50
        }

        if(startdate.current){
            searchObject.startdate = dateToYYYYMMDD(startdate.current)
        }

        if(enddate.current){
            searchObject.enddate = dateToYYYYMMDD(enddate.current)
        }

        if(Array.isArray(selected_doctypes.current)){
            searchObject.doctypes = selected_doctypes.current.map(item => item.split(";")[0]).join(";")
        }

        const params = queryString.stringify(searchObject).replace(/%3B/g, ';');

        const {data:res} = await axios.get(`documents/getbyfilter?${params}`, {
            cancelToken: sourceRef.current.token // Pass the cancel token to the request
        })

        // Save amount days difference between start and end date
        if(startdate.current && enddate.current){
            const diff = Math.abs(differenceInDays(enddate.current, startdate.current))
            setCookie('search_days', diff.toString())
        }

        return res.object
    }

    const { data:testResults, refetch, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage } = useInfiniteQuery({
        queryKey: [`${search_value}_${checked_searchcontent.current.toString()}_${startdate.current?.toString()}_${enddate.current?.toString()}_${JSON.stringify(selectedDoctypes)}`],
        queryFn: getSearchResults,
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages, lastPageParam) => {
            if (lastPage?.length < 50) {
                return undefined
            }
            return lastPageParam + 1
        },
        getPreviousPageParam: (firstPage, allPages, firstPageParam) => {
            if (firstPageParam <= 1) {
                return undefined
            }
            return firstPageParam - 1
        },
        enabled: !!searchParams.get('v')
    })

    useEffect(()=>{
        const searchValue = searchParams.get('v')
        if(searchValue){
            searchvalue.current = searchValue
            setsearch_value(searchValue);
        } 

        const handleEnterKeyPress = (event:KeyboardEvent) => {
            if (event.key === 'Enter') {
                refetch()
            }
        }

        window.addEventListener('keydown', handleEnterKeyPress);

        // Cleanup the event listener when the component unmounts
        return () => {
        window.removeEventListener('keydown', handleEnterKeyPress);
        };
    }, [])

    useEffect(()=>{
        if(doctypes){
            initDoctypeList();
        }
    }, [docgroups])

    const { data:status } = useQuery<Status[] | null>({
        queryKey: [`status`],
        queryFn: async () => {
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_SERVER_LINK}status/list?token=${auth.data?.token}`)
                if(data.errorcode!==0){throw new Error(data.message)}
                return data.object
            } catch (error) {
                console.log(error);
                return null
            }
        },
        refetchOnWindowFocus: false
    })

    useEffect(()=>{
        initDoctypeList()
    }, [searchParams.get('dg'), searchParams.get('dt')])

    const initDoctypeList = () => {
        let a:any = []

        let defaultSelect:any = []
        const dg = searchParams.get('dg');
        const doct = searchParams.get('dt');

        docgroups.forEach(docgroup => {
            let obj: {parent:string, children:Array<string>} = {parent:'', children:[]}
            obj.parent = getItemById(docgroup.nations, "nationid", getWindevLang(i18n.language))?.oms || t('Onbekend')

            if(docgroup.doctypes){
                docgroup.doctypes.forEach(doctype => {
                    if(!hasDoctypeRight(doctype.doctype, doctypes, 'view')){ return; }
                    let dt = getItemById(doctypes, "doctype", doctype.doctype)
                    let full_doctype = '';
                    if(dt){
                        full_doctype = getItemById(dt.docoms, "nationid", getWindevLang(i18n.language))?.oms || ''
                    }
                    obj.children.push(`${doctype.doctype};${full_doctype}`)

                    if(dg && dg === docgroup.docgroupid.toString()){ defaultSelect.push(`${doctype.doctype};${full_doctype}`) }
                    if(doct && doct === doctype.doctype){ defaultSelect.push(`${doctype.doctype};${full_doctype}`) }
                });
            }
            
            a.push(obj);

        });

        setdoctypeList(a);
        setselectedDoctypes(defaultSelect)
        selected_doctypes.current = defaultSelect;
    }

    const addDoctype = (item:string) => {
        setselectedDoctypes(prevState => {
            if (!prevState.includes(item)) {
                selected_doctypes.current = [...prevState, item]
                return [...prevState, item];
            } else {
                selected_doctypes.current = prevState
                return prevState;
            }
        });
        setddlUpdater(ddlUpdater + 1)
        setselectedDoctype('')
    }

    const deleteDoctype = (item:string) => {
        let tmp_selections = [...selectedDoctypes];
        if(tmp_selections.includes(item)){
            const index = tmp_selections.indexOf(item);
            if(index > -1){
                tmp_selections.splice(index, 1);
                selected_doctypes.current = tmp_selections
                setselectedDoctypes(tmp_selections);
            }
        }
    }

    const extensionToIcon = (extension:string) => {
        switch (extension) {
            case 'doc': case 'docx':
                return word_icon
            case 'xlsx':
                return excel_icon
            case 'pdf':
                return pdf_icon
            case 'txt':
                return text_icon
            case 'ppt': case 'pptx':
                return powerpoint_icon
            case 'eml': case 'msg':
                return mail_icon;
            case 'jpg': case 'jpeg': case 'png':
                return image_icon;
            default:
                return unknown_icon
        }
    }

    const getColumns = (results:DocumentObject[]) => {
        if(!metatypeList){ return [] }
        if(!results){ return [] }
        let result:any[] = []
        let metatypeArray:string[] = []
        results.forEach(element => {
            if(element && element.metadata){
                return element.metadata.forEach(md => {
                    if(!metatypeArray.includes(md.metatype)){ metatypeArray.push(md.metatype) }
                })
            }
        });
        result = metatypeArray.filter(mt => {
            const item = metatypeList.find(i=>i.metatype===mt)
            return item?.columndisplay
        })
        return result
    }

    const getStatusIcons = (document:DocumentObject) => {
        let statusIcons:number[] = []

        if(!document){ return []}

        document.status?.forEach(status => statusIcons.push(status))
        
        if(status){
            status.forEach(state => {
                state.metadata?.forEach(meta => {
                    const metaInDoc = document.metadata?.find(i=>i.metatype===meta.Metatype)
                    if(metaInDoc?.metavalue === meta.Metadata){
                        console.log("Metadata status equal")
                        if(!statusIcons.includes(state.statusid)){ statusIcons.push(state.statusid) }
                    }
                })
            })
        }

        return statusIcons
    }

    // De doctype-rechten worden hier bewust niet meer toegepast: autorisatie hoort
    // aan de serverkant. Wat getbyfilter teruggeeft, tonen we. Een client-side filter
    // was toch geen beveiliging, want de response is in de netwerk-tab gewoon leesbaar.
    function filterResults(results:any) {
        if(!Array.isArray(results)) return [];

        return results.filter(doc => !!doc)
    }
    
    useEffect(()=>{
        try {
            let results = testResults?.pages.filter(p=>p !== null).reduce((acc, curr)=>acc.concat(curr), []) || []
            setresults_state(results)
        } catch (err) {
            console.log(err)
        }
    }, [testResults])

    const [results_state, setresults_state] = useState<any[]>([]);

    const {data:results, sorting, updateSorting} = useTable(
        {
            data:results_state,
            sorting:{
                desc:true,
                id:'docdate'
            }
        }
    )

    const visible_results = filterResults(results)

    return (
        <>  
            {(show_filepreview && selectedDocument) && 
                <FilePreview document={selectedDocument} onClose={()=>{setshow_filepreview(false)}}/>
            }

            {(show_detail && selectedDocument) && 
            <Detail onClose={()=>{setshow_detail(false)}}>
                <FileDetail document={selectedDocument} viewFile={()=>{setshow_detail(false); setshow_filepreview(true)}}/>
            </Detail>
            }

            <div className={styles.dashboard}>
                <div className={styles.bg_image}></div>

                <div className={styles.content}>
                    <div className={styles.top_content}>
                        <h1 className='text-3xl font-bold text-white'>{t('Zoeken')}</h1>
                        <p className='text-sm text-white uppercase'>{t('Zoek documenten op basis van jouw zoektermen')}</p>
                    </div>

                    <div className='flex flex-col gap-4 p-8 bg-white border rounded-lg shadow-sm'>
                        <div>
                            <h2 className='text-2xl font-semibold'>{t('Filters')}</h2>
                            <p className="text-sm text-neutral-600"><span className="font-medium">Document types:</span> {(!selectedDoctypes || (Array.isArray(selectedDoctypes) && selectedDoctypes.length === 0)) && <span>alles</span>} {(Array.isArray(selectedDoctypes) && selectedDoctypes.length > 0) && selectedDoctypes?.map((sd,i)=>{if(!hasDoctypeRight(sd.split(';')[0], doctypes, 'view')){ return <></> } return <span key={`sd-${i}`}>{sd.split(';')[1]}{i+1 !== selectedDoctypes.length && ', '}</span>})}</p>
                        </div>
                        <div className='grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3'>
                            <div className="">
                                <Label htmlFor="date">{t('Begin en einddatum')}</Label>
                                <DatePickerWithRangePresetsInput value={{from:startDate, to:endDate}} onDateChange={(range)=>{console.log(range); startdate.current = range?.from; enddate.current = range?.to; setstartDate(range?.from); setendDate(range?.to)}} className="bg-slate-200 rounded-sm min-w-[250px]" placeholder={t('Selecteer een datum') || ''} id="date"/>
                            </div>

                            {(!searchParams.get('dg') && !searchParams.get('dt')) &&
                            <div>
                                <Label htmlFor="doctypes">{t('Documenttypes')}</Label>
                                <GroupDropdown onChange={(v)=>{addDoctype(v)}} list={doctypeList} clearOnSelect placeholder={`${t('Documenttypes')}...`}/>

                                {selectedDoctypes.length > 0 &&
                                <div className={styles.doctypes}>
                                    <p className='text-sm font-medium'>{t('Geselecteerde types')}:</p>
                                    <div className="flex flex-wrap items-center gap-2 text-sm">
                                        {selectedDoctypes.map((item, index) => {
                                            return (
                                                <p onClick={()=>{deleteDoctype(item)}} className='flex items-center gap-1 px-1 border rounded-full cursor-pointer hover:bg-red-50' key={index}>{item.split(';')[1]}<span><X className="w-3"/></span></p>
                                            )
                                        })}
                                    </div>
                                </div>
                                }
                            </div>
                            }

                            <div className="col-span-full">
                                <div className="flex items-end justify-between mb-1">
                                    <Label htmlFor="search">{t('Zoekterm')}</Label>
                                    <Checkbox checked={checkedSearchContent} onChange={(v:React.ChangeEvent<HTMLInputElement>)=>{checked_searchcontent.current = v.currentTarget.checked; setcheckedSearchContent(v.currentTarget.checked)}}><p style={{fontSize:".8rem"}}>{t('Zoeken op inhoud')}</p></Checkbox>
                                </div>
                                
                                <Input id="search" value={search_value} onChange={({target}) => {searchvalue.current = target.value; setsearch_value(target.value)}} placeholder={`${t('Zoekterm')}...`} startEnhancer={<img className="w-4" src={search} alt="search"/>}/>
                            </div>
                            <div className="flex items-center gap-2 col-span-full">
                                <Button disabled={isFetching} onClick={()=>{refetch()}} className="gap-2">
                                    {isFetching && <Loader2 className="w-4 h-4 animate-spin"/>}
                                    {isFetching ? t('Even geduld') : t('Zoeken')}
                                </Button>
                            </div>

                        </div>  
                    </div>

                    {(visible_results.length > 0 && isInterface(results, {} as DocumentObject[])) &&
                    <div className={styles.documents}>
                        <p className={styles.title}>{t('Resultaten')} ({visible_results.length})</p>
                        <Table className="mt-8">
                            <TableHeader>
                                <TableRow>
                                    <TableHead className="p-2">{t('Status')}</TableHead>
                                    <TableHead onClick={()=>{updateSorting({ id:'docdate', desc:!sorting?.desc })}} className="p-2 cursor-pointer whitespace-nowrap hover:underline">
                                        <div className="flex items-center gap-2">
                                            {t('Doc datum')}
                                            <ChevronsUpDownIcon className="w-4 h-4"/>
                                        </div>
                                    </TableHead>
                                    <TableHead onClick={()=>{updateSorting({ id:'doctype', desc:!sorting?.desc })}} className="p-2 cursor-pointer hover:underline">
                                        <div className="flex items-center gap-2">
                                            {t('Type')}
                                            <ChevronsUpDownIcon className="w-4 h-4"/>
                                        </div>
                                    </TableHead>
                                    <TableHead className="p-2"></TableHead>
                                    <TableHead onClick={()=>{updateSorting({ id:'filename', desc:!sorting?.desc })}} className="p-2 cursor-pointer hover:underline">
                                        <div className="flex items-center gap-2">
                                            {t('Bestandsinfo')}
                                            <ChevronsUpDownIcon className="w-4 h-4"/>
                                        </div>
                                    </TableHead>
                                    {getColumns(visible_results)?.map((v, i)=>(
                                        <TableHead onClick={()=>{updateSorting({ id:`metadata[].${v}`, desc:!sorting?.desc })}} key={i} className="cursor-pointer hover:underline">
                                            <div className="flex items-center gap-2">
                                                {metatypeList.find(i=>i.metatype===v)?.metatype_oms?.find(i=>i.nationid===getWindevLang(i18n.language))?.oms || v}
                                                <ChevronsUpDownIcon className="w-4 h-4"/>
                                            </div>
                                        </TableHead>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {visible_results.map((doc, ind)=>{
                                    return(
                                    <TableRow key={ind} className="cursor-pointer hover:bg-blue-50 group" onClick={()=>{setselectedDocument(doc); setshow_filepreview(true)}}>
                                        <TableCell>
                                            <div className="flex items-center gap-1">
                                            
                                                {getStatusIcons(doc).map((status_id, index)=>(
                                                <TooltipProvider key={`${status_id}-${doc.docid}`}>
                                                    <Tooltip delayDuration={50}>
                                                        <TooltipTrigger><img key={status_id} className="w-5 h-5" src={`data:image/png;base64, ${status ? (status.find(i=>i.statusid===status_id)?.icon) : ''}`}/></TooltipTrigger>
                                                        <TooltipContent>{status ? (status.find(i=>i.statusid===status_id)?.description || status.find(i=>i.statusid===status_id)?.name) : ''}</TooltipContent>
                                                    </Tooltip>
                                                </TooltipProvider>
                                                ))}
                                                {doc.remarks?.length > 0 && <MessageCircleIcon className="w-5 h-5 text-teal-400 fill-teal-300"/>}
                                            </div>
                                        </TableCell>
                                        <TableCell className="p-2 group-hover:text-blue-600">{YYYYMMDDtoDate(doc.docdate) ? format(YYYYMMDDtoDate(doc.docdate), "dd/MM/yyyy") : ''}</TableCell>
                                        <TableCell className="p-2 group-hover:text-blue-600">{doctypes ? (doctypes.find(i=>i.doctype===doc.doctype)?.docoms.find(i=>i.nationid === getWindevLang(i18n.language))?.oms) : doc.doctype}</TableCell>
                                        <TableCell className="p-2 group-hover:text-blue-600"><img className="w-6 min-w-[24px] h-6" src={extensionToIcon(doc.filename.split('.')[doc.filename.split('.').length-1])} /></TableCell>
                                        <TableCell className="p-2 group-hover:text-blue-600">
                                            <div className="flex flex-col gap-1 overflow-auto">
                                                <p className="text-inherit">DOCID: {doc.docid}</p>
                                                <p className="text-inherit">{t('Bestand')}: {doc.filename}</p>
                                            </div>
                                        </TableCell>
                                        {getColumns(visible_results)?.map((v, i)=>(
                                            <TableCell key={i}>{doc?.metadata?.find((md:any) => md?.metatype === v)?.metavalue || ''}</TableCell>
                                        ))}
                                    </TableRow>
                                    )})}
                            </TableBody>
                        </Table>

                        <div className="flex justify-center mt-4">
                            <Button onClick={()=>{fetchNextPage()}} disabled={!hasNextPage || isFetchingNextPage} variant='outline' className="gap-2">{isFetchingNextPage && <Loader2 className="w-4 h-4 animate-spin"/>} {hasNextPage ? 'Meer inladen' : 'Einde bereikt'}</Button>
                        </div>
                    </div>
                    }

                    {visible_results.length === 0 && 
                    <div className='px-16 py-8'>
                        <div className='flex flex-col items-center gap-4'>
                            <img className='w-[200px] h-auto' src={empty} alt="Nothing found"/>
                            <div className='flex flex-col items-center justify-center gap-2'>
                                <p className='font-medium text-center'>{t('Geen documenten gevonden')}</p>
                                <p className='text-sm text-center text-neutral-600'>{t('Probeer andere parameters mee te geven')}</p>
                            </div>
                        </div>
                    </div>
                    }

                </div>
            </div>
        </>
    )
}

export default Search;